"use strict";
export function orderCollectFeesSteps(flow) {
  return [flow.collectFees];
}
